import { MDBTooltip } from "mdb-react-ui-kit";
import React, { useState, useEffect } from "react";
import EmailConfigurationModal from "./modals/EmailConfigurationModal";
import MyPackagesModal from "./modals/MyPackagesModal";
import { useSelectFunctions, useSpecialFunctions } from "../functions";

const Header = ({
  logout,
  data,
  setSessionNoLongerExists,
  systemPreferences,
  setSystemPreferences,
}) => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPackagesModal, setShowPackagesModal] = useState(false);
  const [hasUpgrade, setHasUpgrade] = useState(true);
  const { getSystemPreferencesRacing } = useSelectFunctions();
  const { checkHasUpgrade } = useSpecialFunctions();

  const callGetSystemPreferences = async () => {
    const res = await getSystemPreferencesRacing(data.UUID);

    if (res?.error) {
      return;
    } else {
      setSystemPreferences(res);
    }
  };

  useEffect(() => {
    callGetSystemPreferences();
  }, []);

  useEffect(() => {
    if (!systemPreferences.TrackPackage) return;

    const hasUpgradeFlag = checkHasUpgrade(systemPreferences.TrackPackage);
    setHasUpgrade(hasUpgradeFlag);
  }, [systemPreferences.TrackPackage]);

  useEffect(() => {
    const today = new Date().toDateString();
    const lastOpened = localStorage.getItem("packagesModalOpenedDate");

    if (lastOpened === today) {
      setHasUpgrade(false);
    } else {
      setHasUpgrade(true);
    }
  }, []);

  return (
    <nav
      style={{ background: "#006699", height: "62px" }}
      className="nav-fixed"
    >
      <div className="d-flex d-flex justify-content-between m-3">
        <div className="col-md-6">
          <strong className="h5" style={{ color: "#99ddff" }}>
            Racing Feed Client
          </strong>
        </div>
        <div className="col-md-3 text-end">
          <div className="btn-group ">
            <MDBTooltip
              tag="i"
              wrapperProps={{ href: "#" }}
              title="Email Configuration"
            >
              <i
                className="fas fa-regular fa-paper-plane me-3"
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#fff",
                }}
                onClick={() => setShowEmailModal(true)}
              ></i>
            </MDBTooltip>
            {systemPreferences.UpgradeEnabled && (
              <>
                <MDBTooltip
                  tag="i"
                  wrapperProps={{ href: "#" }}
                  title="Packages Upgrade"
                >
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    onClick={() => {
                      setShowPackagesModal(true);
                      localStorage.setItem(
                        "packagesModalOpenedDate",
                        new Date().toDateString(),
                      );

                      setHasUpgrade(false);
                    }}
                  >
                    <i
                      className="fas fa-solid fa-cogs me-3"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    ></i>

                    {hasUpgrade && (
                      <div className="warning-container">
                        <span style={{ color: "#000" }}>!</span>
                      </div>
                    )}
                  </div>
                </MDBTooltip>
              </>
            )}
            <a
              className=""
              href="/#"
              id="navbarDropdownMenuLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="fas fa-user-circle"
                style={{ color: "#ffffff", fontSize: "23px" }}
              />
            </a>
            <ul className="dropdown-menu dropdown-menu-end ">
              <li>
                <a
                  href="/#"
                  className="dropdown-item text-center p-2"
                  style={{
                    backgroundColor: "#6699cc",
                    color: "black",
                  }}
                >
                  <strong>{localStorage.getItem("userName")}</strong>
                </a>
              </li>
              <li>
                <a
                  href="/#"
                  className="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#rmqModal"
                >
                  <i className="fa-solid fa-gear"></i> Settings RMQ
                </a>
              </li>
              <li>
                <a href="/#" className="dropdown-item" onClick={() => logout()}>
                  <i className="fa-solid fa-right-from-bracket"></i> Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {showEmailModal && (
        <EmailConfigurationModal
          show={showEmailModal}
          onClose={() => setShowEmailModal(false)}
          data={data}
        />
      )}
      {showPackagesModal && (
        <MyPackagesModal
          show={showPackagesModal}
          onClose={() => setShowPackagesModal(false)}
          setHasUpgrade={setHasUpgrade}
          data={data}
          setSessionNoLongerExists={setSessionNoLongerExists}
          systemPreferences={systemPreferences}
          setSystemPreferences={setSystemPreferences}
        />
      )}
    </nav>
  );
};

export default Header;
